import { FC } from 'react';
import styled from '@emotion/styled';
import { Image, NakedButton } from '@qga/roo-ui/components';
import { SelfServiceAPI as SelfServiceAPIType } from 'types';
import * as tracking from 'lib/gaTracking/bookingDetailsPageEvents';
import { captureErrorInSentry } from 'lib/captureInSentry';
import { appleWalletButton } from 'images';
import { SelfServiceAPI } from 'apis';
import { useDownloadAppleWalletPassErrorModal } from '../../../Alerts/Modal/DownloadAppleWalletPassError';

const InlineFlexButton = styled(NakedButton)`
  display: inline-flex;
  align-items: center;
`;

const DownloadAppleWalletPassButton: FC<{ booking: SelfServiceAPIType.Booking }> = ({ booking }) => {
  const openDownloadAppleWalletPassErrorModal = useDownloadAppleWalletPassErrorModal();

  const handleClick = async () => {
    tracking.downloadAppleWalletPassLinkSelected('Booking details');
    try {
      await SelfServiceAPI.downloadAppleWalletPass(booking);
    } catch (e) {
      captureErrorInSentry(e);
      openDownloadAppleWalletPassErrorModal();
    }
  };

  return (
    <InlineFlexButton color="brand.primary" aria-label="Download Apple Wallet Pass" onClick={handleClick}>
      <Image src={appleWalletButton} alt="Add to Apple Wallet" height={44} />
    </InlineFlexButton>
  );
};

export default DownloadAppleWalletPassButton;
